import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";

import TextInput from "../components/TextInput";
import { ApiContext, NavigationContext, UserContext } from "../contexts";
import {
  IS_DEV,
} from "../resources/constants";

const SimpleDetailsScreen = observer(() => {
  const apiContext = useContext(ApiContext);
  const userContext = useContext(UserContext);
  const navContext = useContext(NavigationContext);

  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    navContext.setOfferTickerVisible(false);
    navContext.setFooterModePrimary(); // In case the user presses browser-back
    navContext.setNextButtonEnabled(false);
    navContext.setNextBtnText("Start");
    navContext.setBackButtonVisible(false);
    navContext.setRestartButtonVisible(false);
    navContext.setSubtotalVisible(false);
    navContext.setNextBtnOnClick(() => {
      submitForm();
    });
  }, []);

  useEffect(() => {
    if (apiContext.isLoading) {
      navContext.setNextButtonEnabled(false);
      return;
    }
    if (
      userContext.firstName !== null && userContext.firstName.trim() !== "" &&
      userContext.lastName !== null && userContext.lastName.trim() !== "" &&
      userContext.email !== null && userContext.email.trim() !== "" &&
      /\S+@\S+\.\S+/.test(userContext.email) // Email regex
    ) {
      navContext.setNextButtonEnabled(true);
    } else {
      navContext.setNextButtonEnabled(false);
    }
  }, [
    userContext.firstName,
    userContext.lastName,
    userContext.email,
    apiContext.isLoading,
  ]);

  const submitForm = async () => {
    setFirstNameError("");
    setLastNameError("");
    setEmailError("");
    try {
      const result = await apiContext.simpleDetails({
        name: userContext.firstName,
        surname: userContext.lastName,
        email: userContext.email,
        phone: userContext.phone,
        opt_in: userContext.optIn,
      });

      if (result.errors) {
        if (result.errors.name) {
          setFirstNameError(result.errors.name[0]);
        }
        if (result.errors.surname) {
          setLastNameError(result.errors.surname[0]);
        }
        if (result.errors.email) {
          setEmailError(result.errors.email[0]);
        }
      } else if (result.error) {
        alert(result.error);
      } else {
        if(!IS_DEV){
          try {
            // @ts-ignore
            window.gtag("event", "SUCCEEDED", {
              "event_category": "ENQUIRY", 
              "event_label": "pyht-initial-details"
            });
            // @ts-ignore
            window.ttq.track("SubmitForm", {
              "contents": [
                {
                  "content_id": window.location.href,
                  "content_type": "Form Submitted Successfully",
                  "content_name": "pyht-initial-details"
                }
              ]
            });
          } catch (e) {
            console.error(e);
          }
        }
        navContext.goNext();
      }
    } catch (e: any) {
      alert(e.message);
    }
  };

  return (
    <div className={"screen screen-simple-details screen-final-details screen-nsw-final-details container"}>
      <div
        dangerouslySetInnerHTML={{
          __html: apiContext.simpleDetailsSettings.copy,
        }}
      />

      <form className={"final-details-form"}>
        <div className={"form-group fname"}>
          <p className={"label"}>First Name</p>
          <div className={"form-controls"}>
            <TextInput
              placeholder={"First Name*"}
              value={userContext.firstName}
              onChange={(value) => userContext.setFirstName(value)}
              onScreenKeyboard={userContext.isKioskMode}
              disabled={apiContext.isLoading}
            />
            {firstNameError !== "" && (
              <p className={"error-msg"}>{firstNameError}</p>
            )}
          </div>
        </div>
        <div className={"form-group lname"}>
          <p className={"label"}>Last Name</p>
          <div className={"form-controls"}>
            <TextInput
              placeholder={"Last Name*"}
              value={userContext.lastName}
              onChange={(value) => userContext.setLastName(value)}
              onScreenKeyboard={userContext.isKioskMode}
              disabled={apiContext.isLoading}
            />
            {lastNameError !== "" && (
              <p className={"error-msg"}>{lastNameError}</p>
            )}
          </div>
        </div>
        <div className={"form-group email"}>
          <p className={"label"}>Primary Email</p>
          <div className={"form-controls"}>
            <TextInput
              placeholder={"Email*"}
              value={userContext.email}
              onChange={(value) => userContext.setEmail(value)}
              onScreenKeyboard={userContext.isKioskMode}
              disabled={apiContext.isLoading}
            />
            {emailError !== "" && (
              <p className={"error-msg"}>{emailError}</p>
            )}
          </div>
        </div>
        <div className={"form-group form-disclaimer"} dangerouslySetInnerHTML={{ __html: apiContext.finalDetailsSettings.form_disclaimer }} />
      </form>
    </div>
  );
});

export default SimpleDetailsScreen;
